import React, { useLayoutEffect, useRef } from "react";
import { useRouter } from "../../components";
import { SiteLink } from "../../components";
import BottomDrawer from "../../components/bottomDrawer";

export function BottomDock(props) {
  const links = [
    {
      url: "/bistro",
      title: "BISTRO",
      icon: "bistro-Icon.png",
      iconHover: "bistro-Icon.png",
    },
    {
      url: "/function",
      title: "FUNCTIONS",
      icon: "function-Icon.png",
      iconHover: "function-Icon.png",
    },
    {
      url: "/gaming",
      title: "GAMING",
      icon: "gaming-Icon.png",
      iconHover: "gaming-Icon.png",
    },
    // {
    //   url: "/blog",
    //   title: "BLOG",
    //   icon: "blog-Icon.png",
    //   iconHover: "blog-Icon.png",
    // },
    {
      url: "/contact",
      title: "CONTACT",
      icon: "contact-Icon.png",
      iconHover: "contact-Icon.png",
    },
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  };

  const linkElts = links.map((link, index) => (
    <li
      key={index}
      className={`bottomMenu__li ${isCurrent(link.url) ? "selected" : ""}`}
    >
      <SiteLink
        to={link.url}
        className={`bottomMenu__link bottomMenu__link--${index}`}
      >
        <div className="icon">
          <img
            className="normal"
            src={`/assets/navicons/${link.icon}`}
            alt={link.title}
          />
          <img
            className="selected"
            src={`/assets/navicons/${link.iconHover}`}
            alt={link.title}
          />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  ));

  // const bottomMenu = useRef(null);
  // useLayoutEffect(() => {
  //   //console.log('useLayoutEffect');
  //   const slider = new BottomDrawer(bottomMenu.current);
  //   setTimeout(() => slider.init(), 1000)
  // }, [])

  return (
    <>
      <nav className="bottomMenu">
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">{linkElts}</ul>
      </nav>
    </>
  );
}
